import type { ReactNode } from 'react';

import { cn } from '@repo/videa-components/src/lib/utils';

export interface VideaNotesContentHeaderProps {
  patientName: string;
  rightContent?: ReactNode;
  rightSlotClassName?: string;
}

/**
 * Reusable content header for the Voice Note sheet.
 */
export const VideaNotesContentHeader = ({
  patientName,
  rightContent,
  rightSlotClassName,
}: VideaNotesContentHeaderProps) => (
  <div className="vai-flex vai-items-center vai-justify-between vai-w-full vai-gap-4">
    <div className="vai-min-w-0 vai-flex-shrink-0">
      <p
        className="vai-text-lg vai-font-medium vai-text-zinc-900"
        data-testid="patient-name-videa-notes-sheet"
      >
        {patientName}
      </p>
    </div>
    {rightContent != null && (
      <div
        className={cn(
          'vai-flex vai-items-center',
          rightSlotClassName ?? 'vai-flex-shrink-0 vai-gap-2',
        )}
      >
        {rightContent}
      </div>
    )}
  </div>
);
